<div class="bmc-package-filter">
    <div class="bmc-package-filter__header">
        <h4 class="bz-font-weight--semibold">{{ 'DEPLOYMENT.FILTERS' | translate }}</h4>
        <bzg-button-secondary *ngIf="!isAllSelected" [size]="'s'" (click)="onSelectAll()">{{ 'DEPLOYMENT.SELECT_ALL' | translate }}</bzg-button-secondary>
        <bzg-button-secondary *ngIf="isAllSelected" [size]="'s'" (click)="onSelectAll()">{{ 'DEPLOYMENT.DESELECT_ALL' | translate }}</bzg-button-secondary>
    </div>
    <div class="bmc-package-filter__options-list">
        <bzg-checkbox *ngFor="let filterOption of filterOptions"
            name="filterOption.name"
            class="bmc-package-filter__option"
            [(ngModel)]="filterOption.selected"
            [checked]="filterOption.selected"
            (change)="onCheckedChange($event)">
            {{ filterOption.textKey | translate }}
        </bzg-checkbox>
        <!-- <bzg-checkbox name="select-all"
            class="bmc-package-filter__option"
            [(ngModel)]="isAllSelected"
            [checked]="isAllSelected"
            (change)="onSelectAllChange($event)">
            {{ 'DEPLOYMENT.ALL' | translate }}
        </bzg-checkbox> -->
    </div>
</div>
